import { invalidateAllJobExtensionQueries } from "@/modules/work/jobs/extensions/queries";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { formatDateForAPI, invalidateAllQueries } from "utils/utils";
import { createExtension } from "./api";

function buildPayload(values) {
  return{
    ...values,
    billing_date: formatDateForAPI(values.billing_date),
  }
}

export const useCreateBillableExtension = () => {
  return useMutation({
    mutationFn: async ({ values }) => {
      const payload = buildPayload(values);
      const response = await createExtension({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Extension Created Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
};
